module.exports = "https://img.zhijierongxing.com/saas/img/shop_img.0d6c5b0d.png";